module.exports = __webpack_public_path__ + "img/image-56.1365314e.webp";